import {
  BellIcon,
  BookOpenIcon,
  BriefCaseIcon,
  CheckVerifiedIcon,
  CreditCardIcon,
  HelpCircleIcon,
  UserIcon,
} from "../../../../assets/icons";
import { Paths } from "../../../../router/paths";

export const PersonalInfoMenuItem = {
  icon: <UserIcon />,
  labelKey: "layout.profileMenu.personalInfo",
  path: Paths.PERSONAL_INFO,
};

export const MySubscriptionMenuItem = {
  icon: <CheckVerifiedIcon />,
  labelKey: "layout.profileMenu.mySubscription",
  path: Paths.SUBSCRIPTIONS,
};

export const NotificationSettingsMenuItem = {
  icon: <BellIcon />,
  labelKey: "layout.profileMenu.notificationSettings",
  path: Paths.NOTIFICATIONS_SETTINGS,
};

export const MyTicketsMenuItem = {
  icon: <HelpCircleIcon />,
  labelKey: "layout.profileMenu.myTickets",
  path: Paths.SUPPORT_TICKETS,
};

export const MyCoursesMenuItem = {
  icon: <BookOpenIcon />,
  labelKey: "layout.profileMenu.myCourses",
  path: Paths.ACADEMY,
};

export const MyPortfolioMenuItem = {
  icon: <BriefCaseIcon />,
  labelKey: "layout.profileMenu.myPortfolio",
  path: Paths.PORTFOLIOS,
};

export const MyCardsMenuItem = {
  icon: <CreditCardIcon />,
  labelKey: "layout.profileMenu.myCards",
  path: Paths.MY_CARDS,
};

export const MenuItems = {
  "super-admin": {
    PersonalInfoMenuItem,
    NotificationSettingsMenuItem,
    MyCardsMenuItem,
  },
  user: {
    PersonalInfoMenuItem,
    MyPortfolioMenuItem,
    MyCardsMenuItem,
  },
  unauthorized: {},
};
